import React from "react";
import cn from 'classnames';

const Radio = ({ children, onChange, isChecked, value, name, id, disabled , className, hasError}) => {
  return (
    <div
	    /*className={cn('radiobutton', {
	      disabled,
		    isChecked: isChecked == id,
        padding: '10px'
	    })}*/
      className={className + " radiobutton"}
    >
      <input
        name={name}
        type="radio"
        id={id}
        disabled={disabled}
        value={value}
        onChange={() => onChange(value)}
        checked={isChecked == value}
      />
      <label htmlFor={id} className={hasError?'rd-error':''}>{children}</label>
    </div>
  );
};

export default Radio;
